var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 395,
    height: 437,
    viewBox: "0 0 395 437",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 114.291L197.5 219.499L379.375 114.291",
    stroke: "#28CA75",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 422.291V219.291",
    stroke: "#28CA75",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M385 301.624V134.957C384.993 127.65 383.064 120.474 379.407 114.148C375.75 107.822 370.495 102.569 364.167 98.9156L218.333 15.5823C211.999 11.9253 204.814 10 197.5 10C190.186 10 183.001 11.9253 176.667 15.5823L30.8333 98.9156C24.5055 102.569 19.2496 107.822 15.5929 114.148C11.9363 120.474 10.0075 127.65 10 134.957V301.624C10.0075 308.931 11.9363 316.107 15.5929 322.433C19.2496 328.759 24.5055 334.012 30.8333 337.666L176.667 420.999C183.001 424.656 190.186 426.581 197.5 426.581C204.814 426.581 211.999 424.656 218.333 420.999L364.167 337.666C370.495 334.012 375.75 328.759 379.407 322.433C383.064 316.107 384.993 308.931 385 301.624Z",
    stroke: "#4076D9",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2c8daa1d30dbdfee16b7e93e03f3aca5.svg";
export { ForwardRef as ReactComponent };